import axios from 'axios'
import { setupInterceptors } from '@/api/interceptor.js'

import { Languages } from './modules/languages'
import { Profile } from '@/api/modules/profile/index.js'
import { User } from '@/api/modules/user.js'
import { Account } from '@/api/modules/account.js'
import { Sessions } from '@/api/modules/sessions.js'
import { Notifications } from '@/api/modules/notifications.js'
import { Chats } from '@/api/modules/chats.js'
import { Attachments } from '@/api/modules/attachments.js'

import { appConfig } from '@/configs/appConfig.js'
import { Hobbies } from '@/api/modules/hobbies.js'
import { Nationalities } from '@/api/modules/nationalities.js'
import { Locations } from '@/api/modules/location.js'
import { Institutions } from '@/api/modules/institutions.js'
import { Skills } from '@/api/modules/skills.js'
import { Companies } from '@/api/modules/companies.js'
import { Vacancies } from '@/api/modules/vacancies.js'
import { Categories } from '@/api/modules/categories.js'
import { Industries } from '@/api/modules/industries.js'
import { Processes } from '@/api/modules/processes.js'
import { Features } from '@/api/modules/features.js'
import { Help } from '@/api/modules/help.js'

export const http = axios.create({
  baseURL: appConfig.baseURL + '/api',
  timeout: 30000,
  headers: {
    XSystemType: 'talent'
  }
})

setupInterceptors(http)

// Singleton API instances — import directly where needed
// e.g. import { vacanciesApi } from '@/api/index.js'
export const languagesApi = Languages(http)
export const profileApi = Profile(http)
export const userApi = User(http)
export const accountApi = Account(http)
export const sessionsApi = Sessions(http)
export const notificationsApi = Notifications(http)
export const chatsApi = Chats(http)
export const attachmentsApi = Attachments(http)
export const hobbiesApi = Hobbies(http)
export const nationalitiesApi = Nationalities(http)
export const locationsApi = Locations(http)
export const institutionsApi = Institutions(http)
export const skillsApi = Skills(http)
export const companiesApi = Companies(http)
export const vacanciesApi = Vacancies(http)
export const categoriesApi = Categories(http)
export const industriesApi = Industries(http)
export const processesApi = Processes(http)
export const featuresApi = Features(http)
export const helpApi = Help(http)

// Used by the Vue plugin to expose $api on components
export const api = {
  languages: languagesApi,
  profile: profileApi,
  user: userApi,
  account: accountApi,
  sessions: sessionsApi,
  notifications: notificationsApi,
  chats: chatsApi,
  attachments: attachmentsApi,
  hobbies: hobbiesApi,
  nationalities: nationalitiesApi,
  locations: locationsApi,
  institutions: institutionsApi,
  skills: skillsApi,
  companies: companiesApi,
  vacancies: vacanciesApi,
  categories: categoriesApi,
  industries: industriesApi,
  processes: processesApi,
  features: featuresApi,
  help: helpApi
}
